import React from 'react'
import { plural } from '../../sso-workspace/format'
import { dayOf, daysBetween, UTC, zoneName } from '../../date/local-time'

const DAY = 864e5
// The tallest bar, in px (an even number, so half the busiest day is whole).
export const BAR_HEIGHT = 32

const label = key => new Date(`${key}T00:00:00Z`).toLocaleDateString('en-US', { month: 'short', day: 'numeric', timeZone: 'UTC' })
const entries = n => plural(n, 'entry', 'entries')

// Entries per day as a row of bars (the Activity tab's summary): one bar per
// day (in timeZone, the zone the facet counted its days in: the reader's)
// that the window from `from` to `to` touches, the partial first and last
// days included, so every bucket the facet counted is drawn. A day the facet
// leaves out counts 0. Heights scale to the busiest day; a day with anything
// on it is at least 2 px, so it never looks empty. Plain CSS, no chart
// library.
export const DayBars = ({ days, from, to, timeZone = UTC }) => {
  const end = new Date(to).getTime()
  const start = new Date(from).getTime()
  const windowDays = Math.max(1, Math.round((end - start) / DAY))
  const counts = new Map((days || []).map(d => [d.key, d.count || 0]))
  const keys = daysBetween(start, end + 1, timeZone)
  const row = (keys.length ? keys : [dayOf(end, timeZone)]).map(key => ({ key, count: counts.get(key) || 0 }))
  const busiest = row.reduce((best, d) => (d.count > best.count ? d : best), { count: 0 })
  const span = `the last ${windowDays} ${windowDays === 1 ? 'day' : 'days'}`
  const zone = `days in ${zoneName(timeZone)}`
  const name = busiest.count
    ? `Entries per day over ${span} (${zone}). Busiest: ${label(busiest.key)}, ${entries(busiest.count)}.`
    : `No entries in ${span}.`

  return (
    <div className="au-bars" role="img" aria-label={name} style={{ height: BAR_HEIGHT }}>
      {row.map(d =>
        <span
          key={d.key}
          className="au-bar"
          title={`${label(d.key)}: ${entries(d.count)}`}
          style={{ height: `${d.count ? Math.max(2, Math.round((d.count / busiest.count) * BAR_HEIGHT)) : 0}px` }}
        />)}
    </div>
  )
}
